/**
 * ClosedRoomBanner — read-only banner displayed when a room is closed.
 */

import { Lock } from '@digital-twins/design-system/icons'

export function ClosedRoomBanner() {
  return (
    <div
      className="flex items-center justify-center gap-2 bg-twin-chat-surface/60 border-t border-twin-chat-divider/20 px-4 py-3"
      data-testid="closed-room-banner"
    >
      <Lock className="h-4 w-4 text-twin-chat-fg-muted" />
      <span className="text-sm text-twin-chat-fg-muted font-medium">
        This focus group is closed. Messages are read-only.
      </span>
    </div>
  )
}
